import moment from 'moment'
import numeral from "./plugins/numeral-plugin";
import assets from "./helpers/assets";

const dateFilters = {
  formatDate (date, format) {
    return moment(date).format(format || 'MM/DD/YYYY')
  },

  formatDatetime (date, format) {
    return moment(date).format(format || 'MM/DD/YYYY hh:mm:ss A')
  },

  formatAgo(date) {
    return moment(date).fromNow()
  }
}

const numeralFilters = {
  shortNumber: (n) => {
    return numeral(n).format('(0.[0]a)')
  },
  formatNumberInteger: (n) => {
    return numeral(n).format('0,0')
  },
  formatMilliseconds: (n) => {
    return numeral(n / 1000).format('00:00:00')
  }
}

const durationFilters = {
  secondsToMinutes: (v) => {
    const secNum = parseInt(v, 10)
    const hours = Math.floor(secNum / 3600) % 24
    const minutes = Math.floor(secNum / 60) % 60
    const seconds = secNum % 60

    return [hours, minutes, seconds]
      .map(v => v < 10 ? '0' + v : v)
      .filter((v, i) => v !== '00' || i > 0)
      .join(':')
  },
  secondsToHours(v){
    let secNum = parseInt(v, 10)
    var hours   = Math.floor(secNum / 3600)
    var minutes = Math.floor(secNum / 60) % 60
    var seconds = secNum % 60

    return [hours,minutes,seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v,i) => v !== "00" || i > 0)
      .join(":")
  },
}

const assetsFilter = {
  assetUrl: (path) => {
    return assets.assetUrl(path)
  },

  assetsHost: () => {
    return assets.assetsHost()
  }
}

export { dateFilters, numeralFilters, durationFilters, assetsFilter }
